import { useFormContext } from "react-hook-form";
import FormField from "@src/components/FormField/FormField";
import Input from "@src/components/Input/Input";
import AvatarPickerLogic from "@src/components/AvatarPicker/AvatarPicker.logic";
import { useParams } from "react-router";
import UserAccessGrant from "./UserAccessGrant/UserAccessGrant";

interface IProps {
    avatar: string;
}
const CharacterMetaForm = ({ avatar }: IProps) => {
    const {
        setValue,
        register,
        formState: { errors },
    } = useFormContext();
    /**
     * Sets the given blob to the form, both in the input and in react-hook-form
     * @param blob   The blob created (by the Avatar Picker for ex.)
     */
    const setAvatar = (blob: Blob | null) => {
        if (blob == null) {
            return;
        }
        let file = new File([blob], "avatar.jpg", {
            type: "image/jpeg",
            lastModified: new Date().getTime(),
        });
        let container = new DataTransfer();
        container.items.add(file);
        const avatarInput = document.querySelector(
            "input[name='avatar']",
        ) as HTMLInputElement;
        avatarInput!.files = container.files;
        setValue("avatar", container.files[0]);
        const changeEvent = new Event("change", { bubbles: true });
        avatarInput!.dispatchEvent(changeEvent);
    };

    const { id } = useParams();
    return (
        <>
            {id != null ? <UserAccessGrant characterId={id} /> : null}
            <h4>Character information :</h4>
            <div className="form__group">
                <FormField errors={errors} name="first_name">
                    <Input
                        type="text"
                        name="first_name"
                        placeholder="First Name"
                        register={register}
                    />
                </FormField>
            </div>
            <div className="form__group">
                <FormField errors={errors} name="last_name">
                    <Input
                        type="text"
                        name="last_name"
                        placeholder="Last Name"
                        register={register}
                    />
                </FormField>
            </div>
            <div className="form__group">
                <FormField
                    errors={errors}
                    name="is_public"
                    displayName="Make character public ?"
                >
                    <Input
                        type="checkbox"
                        name="is_public"
                        placeholder="Is Public ?"
                        register={register}
                    />
                </FormField>
                <p className="info">
                    Setting your character as "public" will allow any{" "}
                    <strong>logged in</strong> user to view their sheet.
                    <br /> This does not grant any editing/ associating rights.
                </p>
            </div>
            <div className="form__group">
                <FormField errors={errors} name="avatar">
                    <AvatarPickerLogic
                        value={avatar ? avatar : ""}
                        setValue={setAvatar}
                    />
                </FormField>
            </div>
        </>
    );
};
export default CharacterMetaForm;
